import { Dialog } from "@headlessui/react";
import {
  EllipsisVerticalIcon,
  ExclamationCircleIcon,
  PlusCircleIcon,
  UserGroupIcon,
  UserPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import { DataContext } from "../../helper/HelperOne";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Country, State, City } from "country-state-city";
import TopFilters from "../Utility/TopFilters";
import TopStats from "../Utility/TopStats";
import LeadEmployeesList from "./LeadEmployeesList";
import HeaderWithAction from "../Utility/HeaderWithAction";
import { useLocation, useNavigate } from "react-router-dom";
import LabelTopView from "../Utility/LabelTopView";
import { UserRoundCogIcon, Users } from "lucide-react";
import UpdateConfirmation from "../Utility/UpdateConfirmation";
import { PencilSquareIcon } from "@heroicons/react/20/solid";

function LeadEmployeeCreate() {
  const location = useLocation();
  const { id_crypt, showForm } = location.state || {};
  const navigate = useNavigate();

      const [filterParams, setFilterParams] = useState(""); 
  

  const user = JSON.parse(localStorage.getItem("user"));
  const employeePermission = user?.employee_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );

  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const employeePermissionForEdit =
    userForEdit?.employee_role_based_access?.some(
      (access) => access.label_id == 3 && access.label_value != 0
    );

  const { searchData } = useContext(DataContext);

  const [openDialogBoxForEmployees, setOpenDialogBoxForEmployees] =
    useState(false);
  const [saveBtn, setSaveBtn] = useState("save");
  const [employeesDataList, setEmployeesDataList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [paginationEmployeeData, setPaginationEmployeeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [editIdCryptForEmployees, setEditIdCryptForEmployees] = useState(null);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialogForTransaction, setDialogForTransaction] = useState(false);

  const [employeesDatas, setEmployeesDatas] = useState({
    name: "",
    employee_phone: "",
    date_of_birth: "",
    // file_name: "",
    // image_name: "",
    contact_person_name: "",
    contact_person_phone: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    pincode: "",
    official_number: "",
    official_email: "",
    password: "",
    date_of_joining: "",
    aadhar_number: "",
    pan_number: "",
    uan_number: "",
    epf_number: "",
    esi_number: "",
    community: "",
  });

  const [employeeImage, setEmployeeImage] = useState("");
  const [fileImage, setFileImage] = useState("");

  const mergedEmployeesWithImages = {
    ...employeesDatas,
    ...fileImage,
    ...employeeImage,
  };
  const [dialogOpenForUpdate, setDialogOpenForUpdate] = useState(false);

  const [employeework, setEmployeeWork] = useState([
    {
      educational_qualification: "",
      company_name: "",
      years: "",
    },
  ]);

  const [filterData, setFilterData] = useState({
    name: "",
    official_email: "",
    official_number: "",
  });


  // const fetchEmployeesData = async (page = 1) => {
  //   const token = localStorage.getItem("token");

  //   try {
  //     const apiUrl = searchData
  //       ? `public/api/admin/employees/pagination?page=${page}&search=${searchData}`
  //       : `public/api/admin/employees/pagination?page=${page}`;

  //     const response = await axios.get(apiUrl, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     if (response.data) {
  //       setDialogForTransaction(true);
  //     }
  //     setEmployeesDataList(response.data.employees.data);
  //     setPaginationEmployeeData(response.data.employees);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const fetchEmployeesData = async (page = 1, queryParams = "") => {
    const token = localStorage.getItem("token");

    try {
        // Construct API URL with search and filters
        const apiUrl = `public/api/admin/employees/pagination?page=${page}${
            queryParams ? `&${queryParams}` : ""
        }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;

  

        const response = await axios.get(apiUrl, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data) {
            setDialogForTransaction(true);
        }

        // Update state with employees data
        setEmployeesDataList(response.data.employees.data);
        setPaginationEmployeeData(response.data.employees);
    } catch (error) {
        console.error("Error fetching employees data:", error);
    }
};


useEffect(() => {
  fetchEmployeesData(currentPage, filterParams);
}, [searchData, currentPage, filterParams]);  // ✅ Now updates when filters change


  const fields = [
    {
      name: "name",
      type: "text",
      placeholder: "Enter Name",
      componentType: "select",
      options: Array.from(
        new Set(employeesDataList.map((employees) => employees.name))
      ).map((name) => ({
        value: name,
        label: name,
      })),
    },
    {
      name: "official_email",
      type: "email",
      placeholder: "Enter Email",
      componentType: "select",
      options: employeesDataList.map((employees) => ({
        value: employees.employeeorganizationalinfo?.official_email || "",
        label: employees.employeeorganizationalinfo?.official_email || "",
      })),
    },
    {
      name: "official_number",
      type: "tel",
      placeholder: "Enter Phone Number",
      componentType: "select",
      options: employeesDataList.map((employees) => ({
        value: employees.employeeorganizationalinfo?.official_number || "",
        label: employees.employeeorganizationalinfo?.official_number || "",
      })),
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  

  const handleFilter = () => {
    const queryParams = new URLSearchParams();

    if (filterData.name) {
        queryParams.append("name", filterData.name);
    }
    if (filterData.official_email) {
        queryParams.append("official_email", filterData.official_email);
    }
    if (filterData.official_number) {
        queryParams.append("official_number", filterData.official_number);
    }

    // Store the query parameters in state
    setFilterParams(queryParams.toString());

    // Fetch data with filters applied
    fetchEmployeesData(1, queryParams.toString());
};


  const handleReset = async () => {
    setFilterData({ name: "", official_email: "", official_number: "" });
    await fetchEmployeesData();
  };

  const handleChangeForEmployees = (e) => {
    const { name, value } = e.target;


    setEmployeesDatas((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleChangeForImages = (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      const allowedTypes = ["pdf", "jpeg", "jpg", "png", "docx"];
      if (!allowedTypes.includes(fileExtension)) {
        toast.error("Invalid file type. Please upload a valid file.");
        return;
      }

      setEmployeeImage(file); // Store the file object directly
    } else {
      setEmployeeImage(null); // Clear if no file is selected
    }
  };

  const handleChangeForFileImage = (e) => {
   
    const file = e.target.files[0];
   

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
    
      const allowedTypes = ["pdf", "jpeg", "jpg", "png", "docx"];

      if (!allowedTypes.includes(fileExtension)) {
        toast.error("Invalid file type. Please upload a valid file.");
        return;
      }

      setFileImage(file); // Store the file object directly
    } else {
      setFileImage(null); // Clear if no file is selected
    }
  };

  // const handleChangeForEmployees = (e) => {
  //   const { name, type, value, files } = e.target;

  //   if (type === 'file') {
  //     setEmployeesDatas((prev) => ({
  //       ...prev,
  //       [name]: files[0], // Take the first file if it's a file input
  //     }));
  //   } else {
  //     setEmployeesDatas((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleContactPersonChange = (e, index) => {
    const { name, value } = e.target;
    const newData = [...employeework];
    newData[index][name] = value;
    setEmployeeWork(newData);
  };

  const AddContactPerson = (e) => {
    e.preventDefault();
    setEmployeeWork([
      ...employeework,
      {
        educational_qualification: "",
        years: "",
        company_name: "",
      },
    ]);
  };

  const handleRemoveContactPerson = (index) => {
    const newData = [...employeework];
    newData.splice(index, 1);
    setEmployeeWork(newData);
  };

  const handleAddEmployee = () => {
    setOpenDialogBoxForEmployees(true);
    setSaveBtn("save");
    setEmployeesDatas({
      name: "",
      employee_phone: "",
      date_of_birth: "",
      file_name: "",
      image_name: "",
      contact_person_name: "",
      contact_person_phone: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      pincode: "",
      official_number: "",
      official_email: "",
      password: "",
      date_of_joining: "",
      aadhar_number: "",
      pan_number: "",
      uan_number: "",
      epf_number: "",
      esi_number: "",
    });
    setEmployeeWork([
      {
        educational_qualification: "",
        company_name: "",
        years: "",
      },
    ]);
    setFileImage(null);
    setEmployeeImage(null);
  };

  const handleSubmitForEmployee = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("name", employeesDatas.name);
      formData.append("employee_phone", employeesDatas.employee_phone);
      formData.append("date_of_birth", employeesDatas.date_of_birth);
      formData.append(
        "contact_person_name",
        employeesDatas.contact_person_name
      );
      formData.append(
        "contact_person_phone",
        employeesDatas.contact_person_phone
      );
      formData.append("address_1", employeesDatas.address_1);
      formData.append("address_2", employeesDatas.address_2);
      formData.append("city", employeesDatas.city);
      formData.append("state", employeesDatas.state);
      formData.append("pincode", employeesDatas.pincode);
      formData.append("official_number", employeesDatas.official_number);
      formData.append("official_email", employeesDatas.official_email);
      formData.append("password", employeesDatas.password);
      formData.append("date_of_joining", employeesDatas.date_of_joining);
      formData.append("aadhar_number", employeesDatas.aadhar_number);
      formData.append("pan_number", employeesDatas.pan_number);
      formData.append("uan_number", employeesDatas.uan_number);
      formData.append("epf_number", employeesDatas.epf_number);
      formData.append("esi_number", employeesDatas.esi_number);
      formData.append("community", employeesDatas.community);

      if (employeeImage) {
        formData.append("employeeImage", employeeImage); // File object for submission
      }

      if (fileImage) {
        formData.append("fileImage", fileImage); // File object for submission
      }

      // if (employeeImage.file_name) {
      //     formData.append('file_name', employeeImage.file_name); // Display name for reference
      // }

      employeework.forEach((work, index) => {
        formData.append(
          `employeework[${index}][educational_qualification]`,
          work.educational_qualification
        );
        formData.append(
          `employeework[${index}][company_name]`,
          work.company_name
        );
        formData.append(`employeework[${index}][years]`, work.years);
      });

      
      const response = await axios.post(
        "public/api/admin/employees/store",
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        toast.success(response.data.message);
        await fetchEmployeesData();
        setOpenDialogBoxForEmployees(false);
      }
    } catch (error) {
    
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEditForEmployee = async (id_crypt) => {
    setIsEditing(false);
    setOpenDialogBoxForEmployees(true);
    toast.success("Now You Can Edit This Employee");
    setEditIdCryptForEmployees(id_crypt);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/employees/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

console.log(response.data.employee,"employee buddyN");


      setEmployeesDatas((prev) => ({
        ...prev,
        name: response.data.employee.name,
        employee_phone: response.data.employee.employee_phone,
        date_of_birth: response.data.employee.date_of_birth,
        file_name: response.data.employee.file_name,
        image_name: response.data.employee.image_name,
        contact_person_name: response.data.employee.contact_person_name,
        educational_qualification:
          response.data.employee.educational_qualification,
        company_name: response.data.employee.company_name,
        years: response.data.employee.years,
        contact_person_phone: response.data.employee.contact_person_phone,
        address_1: response.data.employee.address_1,
        address_2: response.data.employee.address_2,
        city: response.data.employee.city,
        state: response.data.employee.state,
        pincode: response.data.employee.pincode,
        official_number:
          response.data.employee?.employeeorganizationalinfo?.official_number ||
          "",
        official_email:
          response.data.employee?.employeeorganizationalinfo?.official_email ||
          "",
        password:
          response.data.employee?.employeeorganizationalinfo?.password || "",
        date_of_joining:
          response.data.employee?.employeeorganizationalinfo?.date_of_joining ||
          "",
        aadhar_number:
          response.data.employee?.employeeuniqueinfo?.aadhar_number,
        pan_number: response.data.employee?.employeeuniqueinfo?.pan_number,
        uan_number: response.data.employee?.employeeuniqueinfo?.uan_number,
        epf_number: response.data.employee?.employeeuniqueinfo?.epf_number,
        esi_number: response.data.employee?.employeeuniqueinfo?.esi_number,
        community: response.data.employee?.employeeuniqueinfo?.community,
      }));

      const employeeworkdetails = response.data.employee?.employeeworkdetails || [];

console.log(employeeworkdetails, "gruu");

setEmployeeWork(
  employeeworkdetails.map((emp) => ({
    educational_qualification: emp.educational_qualification || "",
    company_name: emp.company_name || "",
    years: emp.years || "",
  }))
);

    } catch (err) {
 
      toast.error(err.response.data.message);
    }
  };

  const handleUpdateForEmployeeConfirmation = async (e) => {
    e.preventDefault();
    setDialogOpenForUpdate(true);
  };

  const handleUpdateForEmployee = async (e) => {
    e.preventDefault();
    setDialogOpenForUpdate(true);
    try {
      const formData = new FormData();

      formData.append("name", employeesDatas.name);
      formData.append("employee_phone", employeesDatas.employee_phone);
      formData.append("date_of_birth", employeesDatas.date_of_birth);
      formData.append(
        "contact_person_name",
        employeesDatas.contact_person_name
      );
      formData.append(
        "contact_person_phone",
        employeesDatas.contact_person_phone
      );
      formData.append("address_1", employeesDatas.address_1);
      formData.append("address_2", employeesDatas.address_2);
      formData.append("city", employeesDatas.city);
      formData.append("state", employeesDatas.state);
      formData.append("pincode", employeesDatas.pincode);
      formData.append("official_number", employeesDatas.official_number);
      formData.append("official_email", employeesDatas.official_email);
      formData.append("password", employeesDatas.password);
      formData.append("date_of_joining", employeesDatas.date_of_joining);
      formData.append("aadhar_number", employeesDatas.aadhar_number);
      formData.append("pan_number", employeesDatas.pan_number);
      formData.append("uan_number", employeesDatas.uan_number);
      formData.append("epf_number", employeesDatas.epf_number);
      formData.append("esi_number", employeesDatas.esi_number);
      formData.append("community", employeesDatas.community);

      if (employeeImage) {
        formData.append("employeeImage", employeeImage); // File object for submission
      }

      if (fileImage) {
        formData.append("fileImage", fileImage); // File object for submission
      }

      // if (employeeImage.file_name) {
      //     formData.append('file_name', employeeImage.file_name); // Display name for reference
      // }

   

      employeework.forEach((work, index) => {
        formData.append(
          `employeework[${index}][educational_qualification]`,
          work.educational_qualification
        );
        formData.append(
          `employeework[${index}][company_name]`,
          work.company_name
        );
        formData.append(`employeework[${index}][years]`, work.years);
      });


      const response = await axios.post(
        `public/api/admin/employees/update/${editIdCryptForEmployees}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        toast.success(response.data.message);
        await fetchEmployeesData();
        setOpenDialogBoxForEmployees(false);
        setDialogOpenForUpdate(false);
      }
    } catch (error) {
    
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchEmployeesData();
      setOpenDialogBoxForEmployees(false);
      if (showForm) {
        navigate("/crm/lead_dashboard"); // Redirect to Dashboard
      } else {
        navigate(location.pathname, {
          state: { ...location.state, showForm: false },
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const statsFieldNames = [
    {
      title: "Total Employees",
      value: employeesDataList.length,
      color: "blue",
      bg: "bg-blue-50",
      link: "/crm/employees",
    },
    {
      title: "Active Employees",
      value: employeesDataList.filter((item) => item.status === 1).length,
      color: "green",
      bg: "bg-green-50",
      link: "/crm/employees/active",
    },
    {
      title: "Inactive Employees",
      value: employeesDataList.filter((item) => item.status === 0).length,
      color: "red",
      bg: "bg-red-50",
      link: "/crm/employees/inactive",
    },
  ];

  return (
    <>
      <LabelTopView label="Employee Overview" icon={<UserRoundCogIcon />} />

      <TopStats statsFieldNames={statsFieldNames} />

      <HeaderWithButton
        title="Employees"
        description="employees"
        buttonText="Employee"
        onButtonClick={handleAddEmployee}
        showButton={employeePermission}
      />

      <TopFilters
        fields={fields}
        filterData={filterData}
        handleChange={handleChange}
        handleFilter={handleFilter}
        handleReset={handleReset}
      />

      <LeadEmployeesList
        setEmployeesDataList={setEmployeesDataList}
        employeesDataList={employeesDataList}
        paginationEmployeeData={paginationEmployeeData}
        // setEditId={setEditId}
        setOpenDialogBoxForEmployees={setOpenDialogBoxForEmployees}
        setEmployeesDatas={setEmployeesDatas}
        employeesDatas={employeesDatas}
        editId={editId}
        setEditId={setEditId}
        setSaveBtn={setSaveBtn}
        fetchEmployeesData={fetchEmployeesData}
        setEmployeeWork={setEmployeeWork}
        setCurrentPage={setCurrentPage}
        setEditIdCryptForEmployees={setEditIdCryptForEmployees}
        setIsEditing={setIsEditing}
        setLoading={setLoading}
        id_crypt={id_crypt}
        showForm={showForm}
        filterParams={filterParams}
      />

      {openDialogBoxForEmployees && (
        <Dialog
          open={openDialogBoxForEmployees}
          onClose={() => {}}
          className="relative z-10"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className=" flex min-h-full items-end justify-center p-4 text-center sm:items-center  md:min-h-screen sm:p-0">
              <Dialog.Panel className="my-auto relative bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                <div
                  className="flex justify-between p-4 text-white sticky top-0"
                  style={{ backgroundColor: "#6366f1" }}
                >
                  <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase">
                    Employee INFO
                  </h1>

                  <div className="flex gap-2">
                    {isEditing && (
                      <div className="relative">
                        <button
                          type="button"
                          className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                          aria-expanded={isOpenEdit}
                        >
                          <PencilSquareIcon
                            // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                            onClick={() => {
                              handleEditForEmployee(editIdCryptForEmployees);
                              setIsOpenEdit(false); // Close after clicking Edit
                            }}
                            className="h-6 w-6 cursor-pointer text-white"
                          />
                        </button>

                        {/* {isOpenEdit && (
                          <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                            <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                              <a
                                href="#"
                                className="block p-2 hover:text-indigo-600"
                                onClick={() => {
                                  handleEditForEmployee(
                                    editIdCryptForEmployees
                                  );
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                              >
                                Edit
                              </a>
                            </div>
                          </div>
                        )} */}
                      </div>
                    )}

                    <XMarkIcon
                      onClick={handleDialogClose}
                      className="h-6 w-6 cursor-pointer"
                    />
                  </div>
                </div>

                {/* <HeaderWithAction
                  title="PROFILE INFO"
                  handleClose={handleDialogClose}
                  isEditing={isEditing}
                  handleEdit={() =>
                    handleEditForEmployee(editIdCryptForEmployees)
                  }
                  showButton={employeePermission}
                /> */}
                <div className="md:grid md:gap-6 p-4">
                  <div className="md:mt-0 md:col-span-2">
                    <form className="grid grid-cols-1  md:grid-cols-1 gap-y-6 ">
                      <div className=" overflow-hidden">
                        <div className="p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Name
                              </label>
                              <div className="mt-2">
                                <input
                                  name="name"
                                  type="text"
                                  value={employeesDatas.name}
                                  onChange={handleChangeForEmployees}
                                  placeholder="Name"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.name && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.name}
                                  </p>
                                )} */}
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="customer_id"
                                  className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                >
                                  Employee Phone
                                </label>
                              </div>

                              <div className="mt-2">
                                <input
                                  name="employee_phone"
                                  type="text"
                                  value={employeesDatas.employee_phone}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Employee Phone"
                                />

                                {/* {requiredFields.employee_phone && (
                                    <p className="mt-1 text-sm text-red-600">
                                      {requiredFields.customer_id}
                                    </p>
                                  )} */}
                              </div>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="date_of_birth"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                DOB
                              </label>
                              <div className="mt-2">
                                <input
                                  name="date_of_birth"
                                  type="date"
                                  value={employeesDatas.date_of_birth}
                                  onChange={handleChangeForEmployees}
                                  placeholder="DOB"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="grid grid-cols-6 gap-6 mt-4 sm:mt-5">
                            {/* <div className="hidden col-span-full sm:col-span-3 lg:col-span-2">
                              <label className="block text-sm font-medium text-gray-700">
                                FILE NAME
                              </label>
                              <input
                                name="file_name"
                                type="text"
                                value={fileImage}
                                onChange={handleChangeForImages}
                                className={`block w-full ${
                                  isEditing && "bg-gray-100"
                                } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                disabled={isEditing}
                                placeholder="FILE NAME"
                              />
                            </div> */}

                            <div className="col-span-full sm:col-span-3 lg:col-span-2">
                              <label className="block text-sm font-medium text-gray-700">
                                Image Upload
                              </label>
                              <div className="mt-2">
                                <label
                                  htmlFor="imageUpload"
                                  className={`flex items-center justify-center w-full px-4 py-2 text-white bg-indigo-600 rounded-md shadow-md cursor-pointer hover:bg-indigo-700 transition-all ${
                                    isEditing
                                      ? "bg-gray-400 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  Upload Image
                                </label>
                                <input
                                  id="imageUpload"
                                  name="employeeImage"
                                  type="file"
                                  onChange={handleChangeForImages}
                                  className="hidden"
                                  disabled={isEditing}
                                />
                                {employeeImage && (
                                  <p className="mt-2 text-sm text-gray-600">
                                    {employeeImage.name}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <h2 className="font-medium mb-2 mt-5 ">
                            Present Address :
                          </h2>

                          <div className="grid grid-cols-6 gap-6 mt-5  bg-white p-4 sm:p-4 rounded-lg">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Address 1
                              </label>

                              <div className="mt-2">
                                <input
                                  name="address_1"
                                  value={employeesDatas.address_1}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Address 1"
                                />
                              </div>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Address 2
                              </label>
                              <div className="mt-2">
                                <input
                                  name="address_2"
                                  value={employeesDatas.address_2}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Address 2"
                                />
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                State
                              </label>
                              <div className="mt-2">
                                <input
                                  name="state"
                                  type="text"
                                  value={employeesDatas.state}
                                  onChange={handleChangeForEmployees}
                                  placeholder="State"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                City
                              </label>
                              <div className="mt-2">
                                <input
                                  name="city"
                                  type="text"
                                  value={employeesDatas.city}
                                  onChange={handleChangeForEmployees}
                                  placeholder="City"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Pincode
                              </label>
                              <div className="mt-2">
                                <input
                                  name="pincode"
                                  type="text"
                                  value={employeesDatas.pincode}
                                  onChange={handleChangeForEmployees}
                                  placeholder="Pincode"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>
                          </div>

                          <h2 className="font-medium mb-2 mt-5 uppercase">
                            organization info :
                          </h2>

                          <div className="grid grid-cols-6  bg-white p-4 sm:p-4 rounded-lg gap-6 mt-5">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Official Number
                              </label>

                              <div className="mt-2">
                                <input
                                  name="official_number"
                                  value={employeesDatas.official_number}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Number"
                                />
                              </div>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Official Email
                              </label>
                              <div className="mt-2">
                                <input
                                  name="official_email"
                                  value={employeesDatas.official_email}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Email"
                                />
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Password
                              </label>
                              <div className="mt-2">
                                <input
                                  name="password"
                                  type="text"
                                  value={employeesDatas.password}
                                  onChange={handleChangeForEmployees}
                                  placeholder="Password"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Date Of Join 
                              </label>
                              <div className="mt-2">
                                <input
                                  name="date_of_joining"
                                  type="date"
                                  value={employeesDatas.date_of_joining || ""}
                                  onChange={handleChangeForEmployees}
                                  placeholder="DATE OF JOINING"
                                  className={`block w-full ${
                                    isEditing ? "bg-gray-100" : "bg-white"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>
                          </div>

                          <h2 className="font-medium mb-2 mt-5 uppercase">
                            EMERGENCY CONTACT DETAILS :
                          </h2>

                          <div className="grid grid-cols-6  bg-white p-4 sm:p-4 rounded-lg gap-6 mt-5">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Contact Person Name
                              </label>

                              <div className="mt-2">
                                <input
                                  name="contact_person_name"
                                  value={employeesDatas.contact_person_name}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Contact Person Name"
                                />
                              </div>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Contact Person Mobile Number
                              </label>
                              <div className="mt-2">
                                <input
                                  name="contact_person_phone"
                                  type="text"
                                  value={employeesDatas.contact_person_phone}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Contact Person Mobile Number"
                                />
                              </div>
                            </div>
                          </div>

                          <h2 className="font-medium mb-2 mt-5 uppercase">
                            UNIQUE INFO :
                          </h2>

                          <div className="grid grid-cols-6 bg-white p-4 sm:p-4 rounded-lg gap-6 mt-5">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Pan Number
                              </label>

                              <div className="mt-2">
                                <input
                                  name="pan_number"
                                  type="text"
                                  value={employeesDatas.pan_number}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Pan Number"
                                />
                              </div>
                            </div>
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Aadhar Number
                              </label>
                              <div className="mt-2">
                                <input
                                  name="aadhar_number"
                                  type="text"
                                  value={employeesDatas.aadhar_number}
                                  onChange={handleChangeForEmployees}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Aadhar Number"
                                />
                              </div>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Uan Number
                              </label>
                              <div className="mt-2">
                                <input
                                  name="uan_number"
                                  type="text"
                                  value={employeesDatas.uan_number}
                                  onChange={handleChangeForEmployees}
                                  placeholder="Uan Number"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                EPF Number
                              </label>
                              <div className="mt-2">
                                <input
                                  name="epf_number"
                                  type="text"
                                  value={employeesDatas.epf_number}
                                  onChange={handleChangeForEmployees}
                                  placeholder="EPF Number"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                ESI Number
                              </label>
                              <div className="mt-2">
                                <input
                                  name="esi_number"
                                  type="text"
                                  value={employeesDatas.esi_number}
                                  onChange={handleChangeForEmployees}
                                  placeholder="ESI Number"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block text-sm font-medium leading-6 text-gray-900">
                                Community
                              </label>
                              <div className="mt-2">
                                <input
                                  name="community"
                                  type="text"
                                  value={employeesDatas.community}
                                  onChange={handleChangeForEmployees}
                                  placeholder="Community"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {/* {requiredFields.contact_person_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.contact_person_phone}
                                  </p>
                                )} */}
                            </div>

                            <div className="col-span-full sm:col-span-3 lg:col-span-2">
                              <label className="block text-sm font-medium text-gray-700">
                                File Upload
                              </label>
                              <div className="mt-2">
                                <label
                                  htmlFor="fileImageUpload"
                                  className={`flex items-center justify-center w-full px-4 py-2 text-white bg-indigo-600 rounded-md shadow-md cursor-pointer hover:bg-indigo-700 transition-all ${
                                    isEditing
                                      ? "bg-gray-400 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  Upload Image
                                </label>
                                <input
                                  id="fileImageUpload"
                                  name="fileImage"
                                  type="file"
                                  onChange={handleChangeForFileImage}
                                  className="hidden"
                                  disabled={isEditing}
                                />
                                {fileImage && (
                                  <p className="mt-2 text-sm text-gray-600">
                                    {fileImage.name}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <h2 className="font-medium mb-2 mt-5 uppercase">
                            Experince Details :
                          </h2>

                          <div className="overflow-x-auto  bg-white p-4 sm:p-4 rounded-md">
                            {/* Header Row */}
                            <div className="min-w-[800px] grid grid-cols-10 gap-6 font-medium text-gray-900  p-2 rounded-md">
                              <div className="col-span-3">
                                Educational Qualification
                              </div>
                              <div className="col-span-3">Company Name</div>
                              <div className="col-span-3">
                                Year Of Experience
                              </div>
                              <div className="col-span-1 text-right">
                                Action
                              </div>
                            </div>

                            {/* Data Rows */}
                            {employeework.map((item, index) => (
                              <div
                                key={index}
                                className="min-w-[800px] grid grid-cols-10 gap-6 border-b p-2 items-center"
                              >
                                {/* Name */}
                                <div className="col-span-3">
                                  <input
                                    name="educational_qualification"
                                    type="text"
                                    value={item.educational_qualification}
                                    onChange={(e) =>
                                      handleContactPersonChange(e, index)
                                    }
                                    placeholder="Educational Qualification"
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* Email */}
                                <div className="col-span-3">
                                  <input
                                    name="company_name"
                                    type="text"
                                    value={item.company_name}
                                    onChange={(e) =>
                                      handleContactPersonChange(e, index)
                                    }
                                    placeholder="Company Name"
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* Phone */}
                                <div className="col-span-3">
                                  <input
                                    name="years"
                                    type="text"
                                    value={item.years}
                                    onChange={(e) =>
                                      handleContactPersonChange(e, index)
                                    }
                                    placeholder="Year Of Experience"
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                    disabled={isEditing}
                                  />
                                </div>

                                {/* Remove Button - Same Line */}
                                <div className="col-span-1 flex items-center justify-end">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemoveContactPerson(index)
                                    }
                                    className="bg-red-500 text-white p-2 rounded-full"
                                  >
                                    <XMarkIcon className="w-2 h-2 sm:w-3 sm:h-3" />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>

                          <button
                            onClick={(e) => AddContactPerson(e)}
                            className="bg-white mt-4  "
                          >
                            <PlusCircleIcon className="w-6 h-6 text-blue-500 bg-white" />
                          </button>

                          {/* Save Button */}
                          <div className="flex justify-end">
                            {saveBtn === "save" ? (
                              <div className="bg-white mt-6">
                                <button
                                  onClick={handleSubmitForEmployee}
                                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Save
                                </button>
                              </div>
                            ) : (
                              <div className="bg-white mt-6">
                                <button
                                  onClick={handleUpdateForEmployeeConfirmation}
                                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                  Update
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}

      <Dialog
        open={dialogOpenForUpdate}
        onClose={() => {}}
        className="relative z-50"
      >
        {/* Background Overlay */}
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-75"
          aria-hidden="true"
        />

        {/* Dialog Content */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            <Dialog.Title className="text-lg font-bold text-gray-800">
              Update Confirmation
            </Dialog.Title>

            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
                <span className="flex items-center justify-center p-2 rounded-full bg-blue-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-blue-600" />
                </span>
                <div className="text-center sm:text-left mt-3 sm:mt-0">
                  <p className="text-gray-600">
                    Are you sure you want to update this item?
                  </p>
                </div>
              </div>
            </div>

            {/* Button Controls */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={() => setDialogOpenForUpdate(false)}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={(e) => handleUpdateForEmployee(e)}
                className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Update
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}

export default LeadEmployeeCreate;
